import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StudentsReportFilterForm } from 'src/app/shared/interfaces';

import { DataWithPagination } from '../../interface';
import { StudentsReportApi } from '../api/students-reports-api';
import { StudentsReport } from '../model';
import { Repository } from './repository';

@Injectable({
  providedIn: 'root',
})
export class StudentsReportRepository extends Repository {
  constructor(private studentsReportApi: StudentsReportApi) {
    super();
  }

  getStudentsReport(filter: StudentsReportFilterForm): Observable<DataWithPagination<StudentsReport[]>> {
    return this.studentsReportApi.getStudentsReport(filter);
  }
}
